import { render, staticRenderFns } from "./About.vue?vue&type=template&id=e5cd5d60&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=e5cd5d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd5d60",
  null
  
)

export default component.exports